import React, { useState } from 'react';

import { Tooltip } from 'antd';
import { FullscreenExitOutlined, FullscreenOutlined } from '@ant-design/icons';

import { IToolbarCommand } from '../../../../../../../models/Shopping';

const CommandExpand: React.FunctionComponent<IToolbarCommand> = ({ disabled, action }) => {
    const [commandActive, setCommandActive] = useState<boolean>(false);

    const _handleCommandAction = () => {
        if (disabled || !action) {
            return;
        }

        setCommandActive(!commandActive);
        action();
    }

    return (
        <div className={`command ${disabled && 'command-disabled'}`} onClick={_handleCommandAction}>
            {commandActive
                ?
                <Tooltip title="Restore">
                    <FullscreenExitOutlined />
                </Tooltip>
                :
                <Tooltip title="Expand">
                    <FullscreenOutlined />
                </Tooltip>
            }
        </div>
    );
}

export default CommandExpand;